export default __webpack_public_path__ + "static/media/ws.f75cf826.svg";